export default __webpack_public_path__ + "0a2e06091457d10d79e171a00c9a83e7.png";